import { Features } from '~src/interfaces/company.interface';
import { UserPermissions } from '~src/interfaces/session.types';

function isRequiredSameInEnabled(required: any, enabled: any): boolean {
  if (required && typeof required === 'object') {
    if (enabled && typeof enabled === 'object') {
      return Object.keys(required).every((requiredKey) => {
        return isRequiredSameInEnabled(required[requiredKey], enabled[requiredKey]);
      });
    } else {
      return false;
    }
  } else {
    return required === enabled;
  }
}

export const filterMenuCallback = (
  reqPermissions: UserPermissions[],
  permissions: UserPermissions[],
  requiredFeatures: Partial<Features>,
  enabledFeatures: Partial<Features>,
): boolean => {
  let ok = isRequiredSameInEnabled(requiredFeatures, enabledFeatures);

  ok =
    ok &&
    reqPermissions.every((requiredPermission) => {
      return permissions.indexOf(requiredPermission) !== -1;
    });

  return ok;
};
